export default "__VITE_ASSET__DAuV0_bq__"